import moment from "moment";
import { convertToPercent, deepCopy, getAppData, getDayDateKey, getFromState, getObjectFilter, getTransformedSegments, round, setUpDate } from "../../../app/util";
import { blockOcc, blockRevPAR } from "./pickup";
import { useDataSummary } from "../../Tile/kpiService";
import dataService from "../../../services/data.service";
import { useSelector } from "react-redux";
import { transformSegmentData } from "../segmentedData";

export function getOtbSegmentData(data, columns, app_state) {
    console.log(data, "  Segmented Data  ==> ", Object.keys(data.data[0]).length);
    // data.data.slice(0,22);

    let setup_data = [];
    data.data.map((item, index) => {
        delete item.HotelTotal;
        let data_columns = [];
        columns.map(col => {
            let dataObj = {};
            let dataArr = [];

            let segmentArr = [];
            for (var segmentKey of Object.keys(item)) {
                segmentArr.push(segmentKey);
            }
            //   console.log(segmentArr);
            // for (var k of Object.keys(item)) { 
            for (let aj = 1; aj < segmentArr.length - 1; aj++) {
                // console.log(item.index.date + " <= Key => " + segmentArr[aj]);
                if (segmentArr[aj] !== "index") {
                    if (col.type === 'dateColumn') {
                        dataObj["date"] = moment(item.index.date).format("MM/DD");
                        dataObj["dow"] = moment(item.index.date).format("ddd");
                        dataObj["segment"] = segmentArr[aj];
                    }
                    if (col.type === 'dataColumn') {
                        col.subcolumns.map(key => {
                            let value = key.value;
                            dataObj[value] = Math.random();//item[segmentArr[aj]]['primary']['value'];
                            // console.log(k," <==> ",(value),"===== ",item[k]['primary'][key.);
                            if (item[segmentArr[aj]]['primary'] !== 'undefined') {
                                //  console.log(value+" <> ",segmentArr[aj]+" = "+aj+"  - ",item[segmentArr[aj]]['primary'] );
                            }
                            // console.log(("Rooms" in item[k]['primary']));
                            // console.log(item[k]['primary'].hasOwnProperty("Rooms"));

                        })
                    }
                }

            }
            // console.log("data => ",dataObj);

            data_columns.push(dataObj);

        })

        setup_data.push(data_columns);
    })
    return setup_data;


}


// Properties without SDLY / SDLY Actuals (e.g. new hotels) have no such blocks in the OTB feed; read them as zeros,
// as the OTB tile shows them, instead of throwing and leaving the merged grid on its previous rows.
const BLANK_OTB_BLOCK = { Occ: 0, Rooms: 0, ADR: 0, RevPAR: 0, Revenue: 0, SellRate: 0 };

// Function to create OTB data for Intellimerge

export const getOtbDataInt = (mainKey, id, tileName, key, index, dataKey, auth, app_state, tileData, ui_state = {}) => {
    let otbData = deepCopy(tileData); //deepCopy(dataService.getSeriesById("OSR").data.data);
    const { dayDate } = app_state.workspace_controls;
    let date = otbData['index'].date;
    let value = key.value;
    mainKey = getDayDateKey(dayDate, mainKey);
    let otbDataKey = otbData[dataKey];
    let otbDataMain = otbDataKey[mainKey] || BLANK_OTB_BLOCK;
    let otbPrimary = otbDataKey["primary"] || BLANK_OTB_BLOCK;
    let otbSdly = ((dayDate === "day") ? otbDataKey["sdly"] : otbDataKey["sdtly"]) || BLANK_OTB_BLOCK;
    let otbSdlyActual = ((dayDate === "day") ? otbDataKey["sdly_actual"] : otbDataKey["sdtly_actual"]) || BLANK_OTB_BLOCK;
    let dataObj = {};

    // Raw block Occ/RevPAR come from the feed computed against fixed Capacity. When the
    // Variable Capacity toggle is on, difference/variance columns must diff toggle-aware
    // values (each block against its own VCapacity), matching what the plain OTB/SDLY
    // columns display.
    const useVarCapacityInt = !!(ui_state?.showVariableCapacity);
    const occOf = (block) => blockOcc(block, useVarCapacityInt);
    const revparOf = (block) => blockRevPAR(block, useVarCapacityInt);

    if (mainKey === "difference_sdly") {
        if (value === "Occ") {
            dataObj[value] = convertToPercent(occOf(otbPrimary) - occOf(otbSdly))
        } else if (value === "RevPAR") {
            dataObj[value] = round(revparOf(otbPrimary) - revparOf(otbSdly))
        } else {
            dataObj[value] = round(otbPrimary[value] - otbSdly[value])
        }
    }
    else if (mainKey === "variance_sdly") {
        let aVal = otbPrimary[value];
        let bVal = otbSdly[value];
        if (value === "Occ") { aVal = occOf(otbPrimary); bVal = occOf(otbSdly); }
        if (value === "RevPAR") { aVal = revparOf(otbPrimary); bVal = revparOf(otbSdly); }
        let varianceData = convertToPercent((aVal - bVal) / bVal);
        dataObj[value] = ((isFinite(varianceData)) ? varianceData : 0.00) + "%";
    }
    else if (mainKey === "pickup_diff_sdly") {
        if (value === "Occ") {
            let pick_diff_Val = occOf(otbSdlyActual) - occOf(otbSdly)
            dataObj[value] = (pick_diff_Val) ? convertToPercent(pick_diff_Val) : 0;
        }else if (value === "ADR") {
            let revAdr = otbSdlyActual['Revenue'] - otbSdly['Revenue'];
            let roomAdr = otbSdlyActual['Rooms'] - otbSdly['Rooms'];
            const pickAdr = revAdr / roomAdr;
            dataObj[value] = isFinite(pickAdr) ? pickAdr : 0;
        }else if (value === "RevPAR") {
            dataObj[value] = round(revparOf(otbSdlyActual) - revparOf(otbSdly))
        }else{
            dataObj[value] = round(otbSdlyActual[value] - otbSdly[value])
        }
        // dataObj[value] = round(otbDataKey["sdly_actual"][value] - otbDataKey["sdly"][value])
    }
    else if (mainKey === "restrictions") {

        let resData = dataService.getSeriesById("GetRestrictions").data;
        // let resData = restDemoData;
        resData = resData && resData.cur ? resData.cur : [];
        let filteredData = getObjectFilter(deepCopy(resData), date, "stay_date")
        let filterRestData = [];
        if (filteredData[0]) {
            Object.keys(filteredData[0]).forEach(function (key) {
                if (filteredData[0][key] === false || filteredData[0][key] === 1) {
                    delete filteredData[0][key];
                }
                if (filteredData[0]["stay_date"]) {
                    //    delete filteredData[0]["stay_date"];
                }
            });
            filterRestData.push(filteredData[0]);
        }

        dataObj[value] = filterRestData;
    } else if (otbData && tileName === "otb") {
        const useVarCapacity = !!(ui_state?.showVariableCapacity);
        if (value == "Occ") {
            const vCap = otbDataMain?.VCapacity || otbDataMain?.Capacity;
            if (useVarCapacity && vCap && otbDataMain?.Rooms !== undefined) {
                dataObj[value] = convertToPercent(otbDataMain.Rooms / vCap);
            } else {
                dataObj[value] = convertToPercent(otbDataMain[value]);
            }
            // VCapIndicator shows only on TY/SDLY columns — never stamp it on Actuals
            if (vCap && !mainKey.includes('_actual')) {
                dataObj._vcap = useVarCapacity ? vCap : otbDataMain.Capacity;
                dataObj._vcapLabel = (useVarCapacity && otbDataMain.VCapacity) ? 'Variable Capacity' : 'Capacity';
                dataObj._vcapDiffers = !!(otbDataMain.VCapacity && otbDataMain.VCapacity !== otbDataMain.Capacity);
            }
            if (["sdly", "sdtly", "sdly_actual", "sdtly_actual"].includes(mainKey)) {
                dataObj._vcapDate = otbData?.index?.sdly_date;
            }
        }
        else if (value == "RevPAR") {
            const vCap = otbDataMain?.VCapacity || otbDataMain?.Capacity;
            if (useVarCapacity && vCap && otbDataMain?.Revenue !== undefined) {
                dataObj[value] = otbDataMain.Revenue / vCap;
            } else {
                dataObj[value] = (otbDataMain[value]) ? otbDataMain[value] : 0;
            }
        }
        else if (value == "SellRate") {
            dataObj[value] = (otbDataMain[value]) ? otbDataMain[value] : 0.00;
        }
        else {
            dataObj[value] = (otbDataMain[value]) ? otbDataMain[value] : 0;
        }
    }
    return dataObj;
}



export const getOtbDataIntTest = (mainKey, id, tileName, key, index, dataKey, auth, app_state, otbSegmented, ui_state = {}) => {
    let value = key.value;
    let dataObj = {};
    let date = otbSegmented.index.date;
    let otbSegmentDataKey = otbSegmented[dataKey];
    let otbSegmentDataPrimary = otbSegmentDataKey["primary"] || BLANK_OTB_BLOCK;
    let otbSegmentDataSdly = otbSegmentDataKey["sdly"] || BLANK_OTB_BLOCK;
    let otbSegmentDataSdlyActual = otbSegmentDataKey["sdly_actual"] || BLANK_OTB_BLOCK;
    let otbSegmentDataMainKey =  otbSegmentDataKey[mainKey] || BLANK_OTB_BLOCK;

    // Segment blocks carry raw fixed-capacity Occ (and often RevPAR = 0), so Occ honors the
    // Variable Capacity toggle and RevPAR is always derived from Revenue and capacity
    // (segment's own, falling back to its primary block's).
    const useVarCapacitySeg = !!(ui_state?.showVariableCapacity);
    const occOf = (block) => blockOcc(block, useVarCapacitySeg);
    const revparOf = (block) => blockRevPAR(block, useVarCapacitySeg, true, otbSegmentDataPrimary);

    if (mainKey === "difference_sdly") {
        if (value === "Occ") {
            dataObj[value] = convertToPercent(occOf(otbSegmentDataPrimary) - occOf(otbSegmentDataSdly))
        } else if (value === "RevPAR") {
            dataObj[value] = round(revparOf(otbSegmentDataPrimary) - revparOf(otbSegmentDataSdly))
        } else {
            dataObj[value] = round(otbSegmentDataPrimary[value] - otbSegmentDataSdly[value])
        }
    }
    else if (mainKey === "variance_sdly") {
        let aVal = otbSegmentDataPrimary[value];
        let bVal = otbSegmentDataSdly[value];
        if (value === "Occ") { aVal = occOf(otbSegmentDataPrimary); bVal = occOf(otbSegmentDataSdly); }
        if (value === "RevPAR") { aVal = revparOf(otbSegmentDataPrimary); bVal = revparOf(otbSegmentDataSdly); }
        let varianceData = convertToPercent((aVal - bVal) / bVal);
        dataObj[value] = ((isFinite(varianceData)) ? varianceData : 0.00) + "%";
    }
    else if (mainKey === "pickup_diff_sdly") {
        if (value === "Occ") {
            let pick_diff_Val = occOf(otbSegmentDataSdlyActual) - occOf(otbSegmentDataSdly)
            dataObj[value] = (pick_diff_Val) ? pick_diff_Val : 0;

        }else if (value === "RevPAR") {
            dataObj[value] = round(revparOf(otbSegmentDataSdlyActual) - revparOf(otbSegmentDataSdly))
        }else{
            dataObj[value] = round(otbSegmentDataSdlyActual[value] - otbSegmentDataSdly[value])
        }
        // dataObj[value] = round(otbSegmentDataSdlyActual[value] - otbSegmentDataSdly[value])
    }
    else if (mainKey === "restrictions" && getAppData(auth, app_state).restrictions.enable) {

        let resData = dataService.getSeriesById("GetRestrictions").data;
        // let resData = restDemoData;
        resData = resData && resData.cur ? resData.cur : [];
        let filteredData = getObjectFilter(deepCopy(resData), date, "stay_date")
        let filterRestData = [];
        if (filteredData[0]) {
            Object.keys(filteredData[0]).forEach(function (key) {
                if (filteredData[0][key] === false || filteredData[0][key] === 1) {
                    delete filteredData[0][key];
                }
                // if (filteredData[0]["stay_date"]) {
                //     //    delete filteredData[0]["stay_date"];
                // }
            });
            filterRestData.push(filteredData[0]);
        }

        dataObj[value] = filterRestData;
    } else if (otbSegmented && tileName === "otb") {
        // debugger;
        if (otbSegmentDataKey) {
            if (value == "Occ") {
                dataObj[value] = convertToPercent(occOf(otbSegmentDataMainKey));
                const vCap = otbSegmentDataMainKey?.VCapacity || otbSegmentDataMainKey?.Capacity;
                if (vCap && !mainKey.includes('_actual')) {
                    dataObj._vcap = useVarCapacitySeg ? vCap : otbSegmentDataMainKey.Capacity;
                    dataObj._vcapLabel = (useVarCapacitySeg && otbSegmentDataMainKey.VCapacity) ? 'Variable Capacity' : 'Capacity';
                    dataObj._vcapDiffers = !!(otbSegmentDataMainKey.VCapacity && otbSegmentDataMainKey.VCapacity !== otbSegmentDataMainKey.Capacity);
                }
                if (["sdly", "sdtly", "sdly_actual", "sdtly_actual"].includes(mainKey)) {
                    dataObj._vcapDate = otbSegmented?.index?.sdly_date;
                }
            } else if (value === "RevPAR") {
                dataObj[value] = round(revparOf(otbSegmentDataMainKey));
            } else {
                dataObj[value] = round(otbSegmentDataMainKey[value]);
            }
        }
    }
    return dataObj;
}